/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planner_NotesInputs */

const en_planner_notes = /** @type {(inputs: Planner_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wishes`)
};

const de_planner_notes = /** @type {(inputs: Planner_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wünsche`)
};

/**
* | output |
* | --- |
* | "Wishes" |
*
* @param {Planner_NotesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_notes = /** @type {((inputs?: Planner_NotesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_NotesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_notes(inputs)
	return en_planner_notes(inputs)
});